import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Page, Pageable } from '../../../model/rest/base';
import { V3Manager } from '../../../model/v3/schools';
import { createPageableParams } from './rest-v3-utils';

@Injectable({
  providedIn: 'root',
})
export class ManagerV3RestService {
  constructor(private http: HttpClient) {}

  private url(schoolId: number, path: string = ''): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}/managers${path}`;
  }

  findManagers(schoolId: number, pageable?: Pageable): Observable<Page<V3Manager>> {
    const params = createPageableParams(pageable);
    return this.http.get<Page<V3Manager>>(this.url(schoolId), { params });
  }

  getManager(schoolId: number, managerId: number): Observable<V3Manager> {
    return this.http.get<V3Manager>(this.url(schoolId, `/${managerId}`));
  }

  deleteManager(schoolId: number, managerId: number): Observable<void> {
    return this.http.delete<void>(this.url(schoolId, `/${managerId}`));
  }
}
